"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionContainer = void 0;
var _SubscriptionWizard = require("../SubscriptionWizard");
var _useSubscriptionTypes = require("../api/useSubscriptionTypes");
var _contexts = require("../contexts");
var _logger = require("../logger");
var _StateContainer = require("./StateContainer");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionContainer = ({
  product
}) => {
  (0, _logger.logDebug)('SubscriptionContainer product:', product);
  const {
    data,
    error,
    isLoading
  } = (0, _useSubscriptionTypes.useSubscriptionTypes)(product);
  (0, _logger.logDebug)('SubscriptionContainer isLoading: ', isLoading, ' | data: ', data, ' | error: ', error);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.TypesProvider, {
    value: {
      types: data?.collection ?? [],
      isLoading
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StateContainer.StateContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionWizard.SubscriptionWizard, {})
    })
  });
};
exports.SubscriptionContainer = SubscriptionContainer;
